import React, { useState, Fragment } from 'react';
import SignUpIndex from '../sections/SignUpIndex';
import SignUpForm from '../sections/SignUpForm';
import SignUpThanks from '../sections/SignUpThanks';

const SignUp = () => {
  const [step, setStep] = useState('index');

  return (
    <Fragment>
      {step === "index" && (
      <SignUpIndex setStep={setStep} />
      )}

      {step === "form" && (
      <SignUpForm setStep={setStep} />
      )}

      {step === "thanks" && (
      <SignUpThanks />
      )}
    </Fragment>
  );
};

export default SignUp;
